/* eslint-disable no-shadow */
const language = 'english'

const englishLang = '/image/flag/uk.svg';
const chineseLang = '/image/flag/china.svg';
const spanishLang = '/image/flag/spain.svg';
const frenchLang = '/image/flag/france.svg';
const italianLang = '/image/flag/italy.svg';
const config = {
  defaultLanguage: language,
  options: [
    {
      languageId: 'english',
      locale: 'en',
      text: 'English',
      icon: englishLang
    },
    {
      languageId: 'chinese',
      locale: 'zh',
      text: 'Chinese',
      icon: chineseLang
    },
    {
      languageId: 'spanish',
      locale: 'es',
      text: 'Spanish',
      icon: spanishLang
    },
    {
      languageId: 'french',
      locale: 'fr',
      text: 'French',
      icon: frenchLang
    },
    {
      languageId: 'italian',
      locale: 'it',
      text: 'Italian',
      icon: italianLang
    }
  ]
};

export function getCurrentLanguage(lang) {
  let selectedLanguage = config.options[0];
  config.options.forEach(language => {
    if (language.languageId === lang) {
      selectedLanguage = language;
    }
  });
  return selectedLanguage;
}
export default config;
